import { createSlotRecipe } from './runtime';

const stepperConfig = {"name":"stepper","slots":["root","step","node","label","link"],"defaultVariants":{"layout":"inline","status":"upcoming"},"variantMap":{"layout":["bar","inline"],"status":["current","done","upcoming"]}}

export const stepper = /* @__PURE__ */ createSlotRecipe(stepperConfig)